<template>
  <div>
    <range-box
        v-if="type === 'height'"
        v-model="value"
        :data="makeArrayNumber(130, 240)"
        label="سانتی متر"
        @input="normalBmi"
    />

    <range-box
        v-if="type === 'weight'"
        v-model="value"
        :data="makeArrayNumber(25, 180)"
        label="کیلوگرم"
    />

    <range-box
        v-if="type === 'age'"
        v-model="value"
        :data="makeArrayNumber(10, 90)"
        label="سال"
    />
  </div>
</template>

<script>
import RangeBox from "./RangeBox";

export default {
  name: "sliderComponent",

  props: ["type"],

  components: {RangeBox},

  computed: {
    value: {
      set(v) {
        this.$emit("input", v);
      },

      get() {
        return this.$attrs.value;
      },
    },
  },

  methods: {
    makeArrayNumber(from, to) {
      return Array.from({length: to - from + 1}, (_, i) =>
          (from + i).toString()
      );
    },
    normalBmi(val){
      this.$emit("normalBmi", val);
    },
  },
};
</script>

<style>
.flicking-viewport {
  direction: ltr !important;

  @apply overflow-hidden relative;
}

.flicking-camera {
  @apply flex relative w-full h-full;
}

.flicking-camera > * {
  @apply flex-shrink-0;
}
</style>